export default function GS_Arithmetic_Operators() {
  return (
    <div className="p-4">
      <h1>GS Arithmetic Operators</h1>
    </div>
  );
}
